import { createFileRoute, redirect } from '@tanstack/react-router'

import { OrganizationAdmin } from '~/components/authorize/OrganizationAdmin'
import { isEbillingEnabled } from '~/constants/featureFlag'
import { Billing } from '~/pages/Billing'

export const Route = createFileRoute('/_authenticated/billing/')({
  // ebilling 連携が無効な環境では請求ページにアクセスさせずホームへリダイレクトする
  beforeLoad: () => {
    if (!isEbillingEnabled) {
      // redirect() は throw して使うのが TanStack Router の作法
      throw redirect({ to: '/' })
    }
  },
  component: () => (
    <OrganizationAdmin thorwError>
      <Billing />,
    </OrganizationAdmin>
  ),
})
